import {
  Component,
  OnInit,
} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "ng2-translate";
import {ServantService} from "../services/servant-service/servant-service";
import {AlertService} from "../services/alert/alert.service";

@Component({
  selector: 'widget-page',
  template: require('./widget-page.component.html'),
  providers: [ServantService],
  styles: [require('./widget-page.component.css')]

})
export class WidgetPageComponent implements OnInit {


  public service_id;

  constructor(private activatedRoute: ActivatedRoute,
              private servantService: ServantService,
              private translate: TranslateService,
              private alertService:AlertService
  ) {

    translate.setDefaultLang('fa');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('fa');
  }

  ngOnInit(): void {


    this.initPage();
    this.activatedRoute.params.subscribe(params => {
      // console.log(params['reserveId']);

      this.service_id = params['serviceId'] ;
      this.initWidget();
    })




  }

  public setPageTitle() {
    // let title = "رزرو" + " : " + this.order_detail.id + " - " + this.order_detail.serviceTitle;
    // this.pageTitle = title;
  }


  public initPage()
  {

    let link ;
    // link=document.createElement('link');
    // link.href='https://reserweb.ir/widget/static/css/app.css';
    // link.rel='stylesheet';
    //
    // document.getElementsByTagName('head')[0].appendChild(link);
    //
    // let script ;
    // script=document.createElement('script');
    // script.type='text/javascript';
    // script.src='https://reserweb.ir/widget/static/js/app.js';
    //
    // document.getElementsByTagName('head')[0].appendChild(script);

  }

  public initWidget()
  {


    var c=document.createElement("DIV");
    c.className="RWWidgetStyle";


    let attr = 'company_url="dentalwebinar"  mode="reserve" theme_font_size="16px" theme_font_family="iransans"  theme_number_font_family="yekan"  theme_width_size="450px"  theme_height_size="350px"';
    if(this.service_id)
      attr += ' service_id='+this.service_id;

    c.innerHTML = '<rw-reserve '+attr+'></rw-reserve>';


    document.getElementById('widget').appendChild(c);

  }


}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/widget-page/widget-page.component.ts